import { Agent } from "../../models/agent-fields";

export interface AgentState {
    agentList: Agent[];
    loading: boolean;
    error: string | null;
}

export const initialState : AgentState ={
    agentList: [],
    loading: false,
    error: null
}